import PaymentReminder from './PaymentReminder.vue';

export * from './PaymentReminder.vue';

export default PaymentReminder;
